// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PB7nS","label":"styles_label__3rHK-"};